<div class="SP-dialog">

    <div mat-dialog-title class="dialog-header">
        <span class="Title">System Prompts</span>

        <span class="close-dilog" (click)="dialogRef.close()">
            <img src="../../../assets/icons/icon-close-red.png" alt="Close">
        </span>
    </div>

    <div class="firstDiv">
        <div class="block">
            <p class="main-text">{{ Data.tabLabel }}</p>
        </div>

        <div class="block">
            <label>DATE</label>
            <p>{{ (created_date | date:'MM-dd-yyyy hh:mm a') || 'N/A' }}</p>
        </div>

        <div class="block">
            <label>UPDATED BY</label>
            <p>{{ created_by_name || 'N/A' }}</p>
        </div>

        <div class="block">
            <label>VERSION</label>
            <p>{{ version?.split('_')[0] }}</p>
        </div>
    </div>

    <mat-dialog-content>
        <p class="tabcont" [innerHTML]="systemPrompt"></p>
    </mat-dialog-content>

</div>